import { servicePayments } from "./servicePayments";

export interface IWorkLogConfigSetting {
  enabled: boolean;
}

export interface IWorkLogConfig {
  allowPayeeCreatedWorkLogs: IWorkLogConfigSetting;
  autoApproveWorkLogs: IWorkLogConfigSetting;
}

export type IWorkLogConfigUpdateRequest = Partial<IWorkLogConfig>;

// Payer: read own work log config
export async function getWorkLogConfig(): Promise<IWorkLogConfig> {
  const response = await servicePayments.get("/work-logging-config");
  return response.data;
}

// Payee: read payer's work log config
export async function getWorkLogConfigForPayee(
  payerId: string
): Promise<IWorkLogConfig> {
  const response = await servicePayments.get(
    `/payer/${payerId}/work-logging-config`
  );
  return response.data;
}

// Payer: update own work log config
export async function updateWorkLogConfig(
  request: IWorkLogConfigUpdateRequest
): Promise<IWorkLogConfig> {
  const response = await servicePayments.patch("/work-logging-config", request);
  return response.data;
}
